import React, { Component, useRef } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter, faFileAlt, faPen, faMoneyBill, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Footer from '../../components/footer'
import { NOME_EMPRESA } from '../../config'
import moment from 'moment'

const estadoInicial = {

    programacao: [],

    dataCancelamento: new Date(),

    alert: { type: '', msg: '' },

    empresaNome: '',

}

class Programacao extends Component {

    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getProgramacao();
    }

    getProgramacao = async () => {
        if (this.props.id === 999999) {
            apiEmployee.get(`/vouchers/getprogramacao/${localStorage.getItem('empresaID')}`)
                .then(res => {
                    this.setState({
                        programacao: res.data,
                        empresaNome: res.data[0].empresaNome,
                    });
                })
        } else {
            apiEmployee.get(`/vouchers/getprogramacao/${this.props.id}`)
                .then(res => this.setState({
                    programacao: res.data
                }))
        }
    }

    getVouchersUnidades = async (unidade, dataProgramacao) => {
        const vouchers = await apiEmployee.get(`/vouchers/getvouchersunidade/${this.props.id}/${unidade}`)
            .then(res => res.data)
            .catch(err => console.error(err));

        let vouchersUtilizados = 0;
        if (vouchers[0]) {
            vouchers.filter(vouchers.data_utilizacao === dataProgramacao).forEach(() => {
                vouchersUtilizados += 1;
            })
        }
        return vouchersUtilizados;
    }



    cancelProgramacao = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja cancelar esta programação? (de {nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.delete(`vouchers/apagarProgramacao/${id}`).then(
                                        async response => {
                                            if (response.data === true) {
                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    cobrarVouchers = (id, empresa) => {

    }

    render() {

        return (
            <div className='page'>
                <Header />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="page-breadcrumb">
                            <h2 id='titulo'>Programação</h2>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <Link to={{
                        pathname: `/addprogramacao/0`
                    }} className='butaoadicionarcardapio add_button_big'>Adicionar programação</Link>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 10 }}>
                    <table className='table-programacao'>
                        <thead>
                            <tr>
                                <th className='column-programacao'>Empresa</th>
                                <th className='column-programacao'>Unidade</th>
                                <th className='column-programacao'>Produto</th>
                                <th className='column-programacao'>Pedidos</th>
                                <th className='column-programacao'>Utilizados</th>
                                <th className='column-programacao'>Data</th>
                                <th className='column-programacao'>Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.programacao.map((programacao) => {
                                return (
                                    <tr>
                                        <td>{programacao.empresaNome}</td>
                                        <td>{programacao.unidadeNome}</td>
                                        <td>{programacao.produtoNome}</td>
                                        <td style={{ textAlign: 'center' }}>{programacao.quantidade}</td>
                                        <td style={{ textAlign: 'center' }}>{programacao?.soma_lancamento}</td>
                                        <td>{moment(new Date(programacao.data).toISOString().split('T')[0]).format('DD/MM/YYYY')}</td>
                                        <td>
                                            <Link
                                                to={{
                                                    pathname: `/addprogramacao/${programacao.chave}`,
                                                    state: { programacao: { ...programacao } }
                                                }}
                                                className={(this.state.dataCancelamento.toISOString() < programacao.data) ? '' : 'prog_disabled'}
                                                onClick={(event) => {
                                                    if (this.state.dataCancelamento.toISOString() >= programacao.data) {
                                                        event.preventDefault();
                                                    }
                                                }}>
                                                <FontAwesomeIcon
                                                    className={`prog_button ${(this.state.dataCancelamento.toISOString() <= programacao.data) ? '' : 'prog_disabled'}`}
                                                    title={(this.state.dataCancelamento.toISOString() <= programacao.data) ? 'Editar' : `Edições só podem ser feitas com 1 dia de antecedência.`}
                                                    icon={faPen}
                                                    color={"#DE3338"}
                                                    size={'1x'} />
                                            </Link>
                                            <FontAwesomeIcon
                                                className={`prog_button ${(this.state.dataCancelamento.toISOString() <= programacao.data) ? '' : 'prog_disabled'}`}
                                                style={{ marginLeft: '10%' }}
                                                title={(this.state.dataCancelamento.toISOString() <= programacao.data) ? 'Cancelar' : `Cancelamentos só podem ser processados com 1 dia de antecedência.`}
                                                icon={faTimes}
                                                color={"#DE3338"}
                                                size={'1x'}
                                                onClick={() => (this.state.dataCancelamento.toISOString() < programacao.data) ? this.cancelProgramacao(programacao.chave, programacao.unidadeNome) : this.setState({
                                                    alert: {
                                                        type: 'error', msg: `Cancelamentos só podem ser processados com 1 dia de antecedência.`
                                                    }
                                                })} />
                                            {this.props.id === 999999 ?
                                                <Link to={{
                                                    pathname: `/cobranca/${programacao.chave}`,
                                                    state: { programacao: { ...programacao } }
                                                }}>
                                                    <FontAwesomeIcon
                                                        className={`prog_button ${(this.state.dataCancelamento.toISOString() > programacao.data && programacao.quantidade > programacao.soma_lancamento && programacao.conferida === null) ? '' : 'prog_disabled'}`}
                                                        style={{ marginLeft: '10%' }}
                                                        title={(this.state.dataCancelamento.toISOString() > programacao.data && programacao.quantidade > programacao.soma_lancamento && programacao.conferida === null) ? 'Debitar' : `Cobrança não válida.`}
                                                        icon={faDollarSign}
                                                        color={"#DE3338"}
                                                        size={'1x'}
                                                        onClick={() => (this.state.dataCancelamento.toISOString() > programacao.data && programacao.quantidade > programacao.soma_lancamento && programacao.conferida === null) ? this.cobrarVouchers(programacao.chave, programacao.chave_pessoa) : this.setState({
                                                            alert: {
                                                                type: 'error', msg: `Cobrança não válida.`
                                                            }
                                                        })} />
                                                </Link>
                                                : null
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => {
    return {
        token: user.token,
        id: user.id,
        cnpj_cpf: user.cnpj_cpf,
        nome: user.nome,
        empresa: user.empresa,
    }
}

export default connect(mapStateToProps, null)(Programacao)